export default __webpack_public_path__ + "static/media/leonard-cotte.671b72a3.jpg";